/**
 * A short two-note chime for an incoming notification — synthesised with WebAudio so there is no
 * asset to ship or fetch. Best-effort: browsers may block audio until the user has interacted with
 * the page, and we never let a sound failure surface as an error.
 */
let ctx: AudioContext | null = null;

export function playChime(): void {
  try {
    const AC =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return;
    ctx ??= new AC();
    if (ctx.state === 'suspended') void ctx.resume();
    const start = ctx.currentTime;
    // A5 → D6: a gentle rising two-note ping.
    [880, 1174.7].forEach((freq, i) => {
      const osc = ctx!.createOscillator();
      const gain = ctx!.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t0 = start + i * 0.12;
      gain.gain.setValueAtTime(0, t0);
      gain.gain.linearRampToValueAtTime(0.14, t0 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.35);
      osc.connect(gain).connect(ctx!.destination);
      osc.start(t0);
      osc.stop(t0 + 0.4);
    });
  } catch {
    // audio is a nicety, never a failure path
  }
}
